import React, { useEffect, useState } from 'react';
import api, { unwrap } from '../utils/api';

// Admin user management — admin-only (the backend gates with
// requireAdminRole). Editors don't see this page in the nav at all.

const ROLES = [
  { value: 'admin',  label: 'Admin', desc: 'Full access to everything.' },
  { value: 'editor', label: 'Editor', desc: 'Products only — no orders, coupons, analytics.' },
];

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [draft, setDraft] = useState({ email: '', name: '', password: '', role: 'editor' });
  const [msg, setMsg] = useState('');

  async function load() {
    setLoading(true);
    try {
      const r = await api.get('/admins/list');
      setUsers(unwrap(r) || []);
    } finally { setLoading(false); }
  }
  useEffect(() => { load(); }, []);

  async function createUser(e) {
    e.preventDefault();
    setMsg('');
    if (!draft.email.trim() || !draft.password) { setMsg('Email and password are required.'); return; }
    try {
      await api.post('/admins/CreateAdmin', { ...draft, email: draft.email.trim() });
      setDraft({ email: '', name: '', password: '', role: 'editor' });
      setMsg('User created.');
      load();
      setTimeout(() => setMsg(''), 3000);
    } catch (e) {
      const m = e?.response?.data?.body;
      setMsg(typeof m === 'string' ? m : 'Could not create user.');
    }
  }

  async function changeRole(u, role) {
    if (u.role === role) return;
    if (!window.confirm(`Change ${u.email} from ${u.role} to ${role}?`)) return;
    try {
      await api.post('/admins/UpdateAdminRole', { _id: u._id, role });
      load();
    } catch (e) {
      const m = e?.response?.data?.body;
      alert(typeof m === 'string' ? m : 'Could not change role.');
    }
  }

  async function deleteUser(u) {
    if (!window.confirm(`Permanently delete ${u.email}? This cannot be undone.`)) return;
    try {
      await api.post('/admins/DeleteAdmin', { _id: u._id });
      load();
    } catch (e) {
      const m = e?.response?.data?.body;
      alert(typeof m === 'string' ? m : 'Could not delete user.');
    }
  }

  return (
    <>
      <h1>Users</h1>

      <div className="card" style={{ maxWidth: 640 }}>
        <h3 style={{ marginTop: 0 }}>Add a user</h3>
        <form onSubmit={createUser}>
          <div className="prop">
            <label>Email</label>
            <input type="email" value={draft.email} onChange={e => setDraft(d => ({ ...d, email: e.target.value }))} />
          </div>
          <div className="prop">
            <label>Name (optional)</label>
            <input value={draft.name} onChange={e => setDraft(d => ({ ...d, name: e.target.value }))} />
          </div>
          <div className="prop">
            <label>Password</label>
            <input type="password" value={draft.password} onChange={e => setDraft(d => ({ ...d, password: e.target.value }))} />
          </div>
          <div className="prop">
            <label>Role</label>
            <select value={draft.role} onChange={e => setDraft(d => ({ ...d, role: e.target.value }))}>
              {ROLES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
            </select>
            <p style={{ fontSize: 12, color: '#666', margin: '4px 0 0' }}>
              {ROLES.find(r => r.value === draft.role)?.desc}
            </p>
          </div>
          <div className="row">
            <button className="btn" type="submit">Create user</button>
            {msg && <span style={{ color: msg.toLowerCase().includes('created') ? '#198754' : '#b42318', fontSize: 13 }}>{msg}</span>}
          </div>
        </form>
      </div>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>All users ({users.length}){loading ? ' — loading…' : ''}</h3>
        <table className="table" style={{ background: '#fff' }}>
          <thead>
            <tr>
              <th>Email</th>
              <th>Name</th>
              <th>Role</th>
              <th>Created</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u._id}>
                <td><code>{u.email}</code></td>
                <td>{u.name || '—'}</td>
                <td>
                  <select value={u.role || 'admin'} onChange={e => changeRole(u, e.target.value)}>
                    {ROLES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
                  </select>
                </td>
                <td style={{ whiteSpace: 'nowrap' }}>{u.createdAt ? new Date(u.createdAt).toLocaleDateString() : '—'}</td>
                <td>
                  <button className="btn small danger" onClick={() => deleteUser(u)}>Delete</button>
                </td>
              </tr>
            ))}
            {users.length === 0 && !loading && (
              <tr><td colSpan={5} style={{ textAlign: 'center', padding: 20, color: '#888' }}>No users yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
